<template>
  <Component :is="viewLayout">
    <template #page-heading>
      <h1 class="heading heading--large">
        Dados personalizados
      </h1>
    </template>

    <template #main>
      <div class="custom-indicators">
        <div
          v-if="customIndicators?.length"
          class="custom-indicators__dashboards"
        >
          <iframe
            v-for="item in customIndicators"
            :key="item.id_dashboard"
            :height="item.height || '720'"
            :src="getIframeSource(item)"
          />
        </div>

        <BasePaneCard
          v-else
          class="height-full"
        >
          <BaseEmptyState>
            <SvgIconInsights/>

            <h3>Você ainda não possui nenhum gráfico personalizado.</h3>
            <p>Entre em contato com a nossa equipe.</p>
          </BaseEmptyState>
        </BasePaneCard>
      </div>
    </template>
  </Component>
</template>

<script>
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import { layoutMixin } from '@/utils/mixins'
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'CustomIndicators',

  mixins: [
    layoutMixin
  ],

  components: {
    BasePaneCard,
    BaseEmptyState
  },

  data () {
    return {
      customIndicators: null
    }
  },

  methods: {
    ...mapMutations('base', {
      setIsLoading: 'SET_IS_LOADING'
    }),

    async fetchCustomIndicators () {
      this.setIsLoading(true)

      try {
        const { VUE_APP_ROOT_API: api } = process.env
        const { id_platform: platformId } = this.$auth.user()
        const url = `${api}integration/quicksight/list-dashboards/${platformId}`
        const response = await axios.get(url)

        this.customIndicators = response.data
      } catch (error) {
        this.customIndicators = null

        throw error
      }

      this.setIsLoading(false)
    },

    getIframeSource (item) {
      const api = 'https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts'
      const accountId = '603651401763'
      const {
        id_dashboard: dashboardId,
        id_sheets: sheetsId,
        id_visuals: visualsId
      } = item
      let source = `${api}/${accountId}/dashboards/${dashboardId}`

      if (sheetsId) {
        source += `/sheets/${sheetsId}`
      }

      if (visualsId) {
        source += `/visuals/${visualsId}`
      }

      return source + '?directory_alias=weclever'
    }
  },

  created () {
    this.fetchCustomIndicators()
  }
}
</script>

<style lang="scss" scoped>
.custom-indicators {
  height: 100%;

  &__dashboards {
    height: 100%;

    iframe {
      width: 100%;
      height: 100%;

      &:not(:first-child) {
        padding-top: 40px;
        margin-top: 40px;
        border-top: 1px solid map-get($colors-util, 'lighter');
      }
    }
  }
}
</style>
